import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { validateQuantity } from "validators/quantity.validator";

@Component({
    selector: 'part-quantity',
    templateUrl: './part-quantity.component.html',
    styleUrls: ['./part-quantity.component.scss'],
  })

  export class PartQuantityComponent implements OnInit {
    @Input() index: number = 0;
    @Input() idModifier: string = "";
    @Input() value: number = 1;
    @Input() max?: number;
    @Input() inputName: string = "";
    @Input() inputPlaceholder: string = "";
    @Input() inputAutoComplete: string = "on";
    @Input() disabled: boolean = false;
    @Input() checkRangeClass?: string = "";
    @Output("onChangeQuantity") onChangeQuantity: EventEmitter<number> = new EventEmitter();
    @ViewChild('quantityInput') quantityInput: ElementRef<HTMLInputElement>;
    decrementDisabled = true;
    containerId: string;
    inputId: string;
    incrementId: string;
    decrementId: string;

    constructor() {

    }
    ngOnInit() {
        this.setDecrementDisabled();
        this.containerId = `quantityContainer_${this.idModifier ? `${this.idModifier}_` : ''}${this.index}`;
        this.inputId = `quantityInput_${this.idModifier ? `${this.idModifier}_` : ''}${this.index}`;
        this.incrementId = `quantityIncrement_${this.idModifier ? `${this.idModifier}_` : ''}${this.index}`;
        this.decrementId = `quantityDecrement_${this.idModifier ? `${this.idModifier}_` : ''}${this.index}`;
    }

    setDecrementDisabled() {
        this.decrementDisabled = this.value === 1;
    }
    updateQuantity(qty: number) {
      if (validateQuantity(qty) && ((this.max !== undefined) ? qty <= this.max : true)) {
        this.value = Number(qty);
        this.onChangeQuantity.emit(qty);
      }
        this.setDecrementDisabled();
    }

    incrementQuantity() {
        const newQuantity = this.value + 1;
        this.updateQuantity(newQuantity);
    }

    decrementQuantity() {
        if (this.value > 1) {
            const newQuantity = this.value - 1;
            this.updateQuantity(newQuantity);
        }
    }

    quantityKeyup(event: KeyboardEvent) {
        switch (event.which) {
            case 38:
                this.incrementQuantity();
                break;
            case 40:
                this.decrementQuantity();
                break;
            default:
                break;
        }
    }

    quantityFocusout(e: FocusEvent) {
        const newQuantity: any = (e.srcElement as HTMLInputElement).value;
        if (validateQuantity(newQuantity)) {
            this.updateQuantity(Number(newQuantity));
        } else {
            (e.srcElement as HTMLInputElement).value = '1';
            this.updateQuantity(1);
        }
    }

    _keyPress(event: KeyboardEvent) {
        const pattern = /[0-9]/;
        const inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar)) {
          // invalid character, prevent input
          event.preventDefault();
        }
    }
  }
